/**
 * Cart Quantity Fix
 * This script fixes issues with quantity updates in the cart drawer
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart Quantity Fix initialized');

  // Function to fix quantity inputs
  function fixQuantityInputs() {
    console.log('Fixing quantity inputs in cart drawer');

    // Get the cart drawer element
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) {
      console.error('Cart drawer element not found - cannot fix quantity inputs');
      return;
    }

    // Find all quantity inputs in the cart drawer
    const quantityInputs = cartDrawer.querySelectorAll('.quantity__input');
    console.log(`Found ${quantityInputs.length} quantity inputs in cart drawer`);

    // Fix each quantity input
    quantityInputs.forEach((input, index) => {
      // Clone the input to remove any existing event listeners
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);

      // Add event listeners to ensure quantity updates are applied immediately
      newInput.addEventListener('change', function(event) {
        console.log(`Quantity input ${index + 1} changed to ${event.target.value}`);
        
        // Find the cart-drawer-items element
        const cartItems = cartDrawer.querySelector('cart-drawer-items');
        if (cartItems) {
          // Get the line item index
          const lineItemIndex = event.target.dataset.index;
          if (lineItemIndex) {
            console.log(`Updating quantity for line item ${lineItemIndex} to ${event.target.value}`);
            
            // Force immediate update via fetch API
            const body = JSON.stringify({
              line: lineItemIndex,
              quantity: parseInt(event.target.value, 10),
              sections: ['cart-icon-bubble', 'cart-drawer']
            });
            
            fetch(`${window.routes.cart_change_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: body
            })
            .then(response => response.json())
            .then(data => {
              console.log('Cart updated successfully:', data);
              
              // Refresh the cart drawer
              if (typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(data);
              } else {
                // Fallback: reload the page
                window.location.reload();
              }
            })
            .catch(error => {
              console.error('Error updating cart:', error);
            });
          }
        }
      });

      // Fix the plus and minus buttons
      const plusButton = newInput.parentNode.querySelector('[name="plus"]');
      const minusButton = newInput.parentNode.querySelector('[name="minus"]');

      if (plusButton) {
        // Clone the button to remove any existing event listeners
        const newPlusButton = plusButton.cloneNode(true);
        plusButton.parentNode.replaceChild(newPlusButton, plusButton);

        // Add event listener to increment quantity
        newPlusButton.addEventListener('click', function() {
          const currentValue = parseInt(newInput.value, 10);
          const maxValue = newInput.hasAttribute('max') ? parseInt(newInput.getAttribute('max'), 10) : Infinity;
          const newValue = Math.min(currentValue + 1, maxValue);
          
          if (newValue !== currentValue) {
            newInput.value = newValue;
            // Update the input value
            newInput.value = newValue;
            
            // Force immediate update via fetch API
            const lineItemIndex = newInput.dataset.index;
            if (lineItemIndex) {
              console.log(`Updating quantity for line item ${lineItemIndex} to ${newValue}`);
              
              const body = JSON.stringify({
                line: lineItemIndex,
                quantity: newValue,
                sections: ['cart-icon-bubble', 'cart-drawer']
              });
              
              fetch(`${window.routes.cart_change_url}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: body
              })
              .then(response => response.json())
              .then(data => {
                console.log('Cart updated successfully:', data);
                
                // Refresh the cart drawer
                if (typeof cartDrawer.renderContents === 'function') {
                  cartDrawer.renderContents(data);
                } else {
                  // Fallback: reload the page
                  window.location.reload();
                }
              })
              .catch(error => {
                console.error('Error updating cart:', error);
              });
            }
          }
        });
      }

      if (minusButton) {
        // Clone the button to remove any existing event listeners
        const newMinusButton = minusButton.cloneNode(true);
        minusButton.parentNode.replaceChild(newMinusButton, minusButton);

        // Add event listener to decrement quantity
        newMinusButton.addEventListener('click', function() {
          const currentValue = parseInt(newInput.value, 10);
          const minValue = newInput.hasAttribute('min') ? parseInt(newInput.getAttribute('min'), 10) : 1;
          const newValue = Math.max(currentValue - 1, minValue);
          
          if (newValue !== currentValue) {
            newInput.value = newValue;
            // Update the input value
            newInput.value = newValue;
            
            // Force immediate update via fetch API
            const lineItemIndex = newInput.dataset.index;
            if (lineItemIndex) {
              console.log(`Updating quantity for line item ${lineItemIndex} to ${newValue}`);
              
              const body = JSON.stringify({
                line: lineItemIndex,
                quantity: newValue,
                sections: ['cart-icon-bubble', 'cart-drawer']
              });
              
              fetch(`${window.routes.cart_change_url}`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: body
              })
              .then(response => response.json())
              .then(data => {
                console.log('Cart updated successfully:', data);
                
                // Refresh the cart drawer
                if (typeof cartDrawer.renderContents === 'function') {
                  cartDrawer.renderContents(data);
                } else {
                  // Fallback: reload the page
                  window.location.reload();
                }
              })
              .catch(error => {
                console.error('Error updating cart:', error);
              });
            }
          }
        });
      }
    });
  }

  // Fix quantity inputs when cart drawer is opened
  document.addEventListener('click', function(event) {
    // Check if the clicked element is a cart button
    if (event.target.closest('[data-cart-drawer-trigger], .js-drawer-open-cart, #cart-icon-bubble, #mobile-cart-icon-bubble')) {
      // Wait for the cart drawer to open
      setTimeout(fixQuantityInputs, 500);
    }
  });

  // Also fix quantity inputs on page load in case cart drawer is already open
  setTimeout(fixQuantityInputs, 1000);

  // Add a mutation observer to detect when the cart drawer becomes active
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            console.log('Cart drawer became active, fixing quantity inputs');
            setTimeout(fixQuantityInputs, 300);
          }
        }
      });
    });

    observer.observe(cartDrawer, { attributes: true });
  }
});
